<template>
    <nav class=fixed-nav>
        <router-link
            class=back
            :class="{ 'hidden' : $route.name == 'home' }"
            :to="{ name : $route.meta.parent || 'home' }"
        >Back</router-link>

        <ul>
            <li class=home><router-link to="/"          ><span>home               </span></router-link></li>
            <li><router-link to="/inside-us"            ><span>inside us          </span></router-link></li>
            <li><router-link to="/on-us"                ><span>on us              </span></router-link></li>
            <li><router-link to="/us-touching"          ><span>us touching        </span></router-link></li>
            <li><router-link to="/us-with-other-people"  ><span>us with other people</span></router-link></li>
            <li><router-link to="/us-and-machines"      ><span>us and machines    </span></router-link></li>
            <li><router-link to="/us-in-place"          ><span>us in place        </span></router-link></li>
            <li><router-link to="/events"               ><span>events             </span></router-link></li>
        </ul>

        <router-link class=about to="/about">Up Close</router-link>

    </nav>
</template>
<script>
export default {
    name : 'FixedNav',
}
</script>